import {Route, Routes} from "react-router-dom"
import App from "pages/App"
import {Dashboard} from "pages/dashboard/Dashboard"
import {LoginForm} from "pages/login/LoginForm"
import {Admin} from "pages/admin/Admin"
import {RealDeviceList} from "pages/admin/devices/RealDeviceList"
import {PathList} from "pages/admin/event/PathList"
import {EnvironmentForm} from "pages/admin/env/EnvironmentForm"
import {OAuth2Redirector} from "pages/login/OAuth2Redirector"
import LocationCategory from "pages/admin/category/LocationCategory"

export const MainRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<App/>}>
                <Route index element={<Dashboard/>}/>
                <Route path="admin" element={<Admin/>}>
                    <Route path="devices" element={<RealDeviceList/>}/>
                    <Route path="event" element={<PathList/>}/>
                    <Route path="category" element={<LocationCategory/>}/>
                    <Route path="env" element={<EnvironmentForm/>}/>
                </Route>
            </Route>
            <Route path="/login" element={<LoginForm/>}/>
            {/*<Route path="/login" element={<Login/>}/>*/}
            <Route path="/oauth2/redirect" element={<OAuth2Redirector/>}/>
        </Routes>
    )
}

